module.exports = __webpack_public_path__ + "static/media/EmployeesTable.f7b60815.svg";